import { httpService } from './httpService';

export interface DashboardStats {
  totalRMCs: number;
  activeRMCs: number;
  totalClients: number;
  activeClients: number;
  totalUsers: number;
  activeUsers: number;
  totalProperties: number;
  activeProperties: number;
  totalRooms: number;
  availableRooms: number;
  totalBookings: number;
  activeBookings: number;
}

export interface RecentActivity {
  id: string;
  type: string;
  action: string;
  entityName: string;
  userName: string;
  createdDate: string;
  icon: string;
  color: string;
}

export interface TopRMC {
  id: string;
  name: string;
  cityName: string;
  totalClients: number;
  totalProperties: number;
  totalRooms: number;
  activeBookings: number;
  createdDate: string;
}

export interface MonthlyStats {
  month: string;
  newUsers: number;
  newClients: number;
  newProperties: number;
  newBookings: number;
  revenue: number;
}


export interface AdminDashboard {
  stats: DashboardStats;
  recentActivities: RecentActivity[];
  topRMCs: TopRMC[];
  monthlyStats: MonthlyStats[];
}

class DashboardService {
  // Keep relative so httpService baseURL is applied; ensure casing matches server (ASP.NET is case-insensitive but proxies may not be)
  private baseUrl = '/api/dashboard';

  async getAdminDashboard(): Promise<AdminDashboard> {
    try {
      const data = await httpService.get<AdminDashboard>(`${this.baseUrl}/admin`, undefined, { unwrap: true, normalize: true });
      return data;
    } catch (e) {
      console.error('Failed fetching admin dashboard:', e);
      throw e;
    }
  }

  async getDashboardStats(): Promise<DashboardStats> {
    return await httpService.get<DashboardStats>(`${this.baseUrl}/stats`, undefined, { unwrap: true });
  }

  async getRecentActivities(count: number = 10): Promise<RecentActivity[]> {
    return await httpService.get<RecentActivity[]>(`${this.baseUrl}/activities?count=${count}`, undefined, { unwrap: true });
  }

  async getTopRMCs(count: number = 5): Promise<TopRMC[]> {
    return await httpService.get<TopRMC[]>(`${this.baseUrl}/top-rmcs?count=${count}`, undefined, { unwrap: true });
  }

  async getMonthlyStats(months: number = 12): Promise<MonthlyStats[]> {
    return await httpService.get<MonthlyStats[]>(`${this.baseUrl}/monthly-stats?months=${months}`, undefined, { unwrap: true });
  }


}

export const dashboardService = new DashboardService();
